<a [routerLink]="['/']">
  <img src="/assets/adnavem_logo_red.svg" alt="" width="152" height="32.86" />
</a>